import * as React from "react";

import { WithTranslation } from "react-i18next";
import GiftCardContainer from "~/containers/GiftCard/GiftCardContainer";
import SupportDashboardLayout from "~/layouts/SupportDashboardLayout";

export default class GiftCardIndex extends React.Component<WithTranslation> {
  public render() {
    return (
      <SupportDashboardLayout>
        <GiftCardContainer />
      </SupportDashboardLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/GiftCard/GiftCardIndex.tsx